module.exports = __webpack_public_path__ + "img/map_17.dbd826b2.png";